import styled from "styled-components";

export const StyledBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 70%); // transparent black
`;
